import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import 'assets/css/global.css';
import 'assets/css/global.js';
import 'react-app-polyfill/ie11';
import Container from 'react-bootstrap/Container';
import ProductsContext from 'contexts/productsContext.js';
import Cookies from 'universal-cookie';
import StickyBox from 'react-sticky-box';
import History from 'history.js';
import CookieConsent from 'react-cookie-consent';
import ReactGA from 'react-ga';
import API_BASE from 'components/API/API_BASE';
import loadable from '@loadable/component';

const Header = loadable(() => import('components/Header.js'));
const Footer = loadable(() => import('components/Footer.js'));
const ScrollToTop = loadable(() => import('components/ScrollToTop.js'));
const SwitchRoute = loadable(() => import('SwitchRoute.js'));
// import Header from 'components/Header.js';
// import Footer from 'components/Footer.js';
// import ScrollToTop from 'components/ScrollToTop';
// import SwitchRoute from 'SwitchRoute.js';

const cookies = new Cookies();
const trackingId = 'G-94729H0S73';

class App extends React.Component {
    constructor() {
        super();
        this.state = {
            productsFromAPI: {
                products: [],
                filters: [],
                count: 0,
                page: 1,
                offset: 0,
                loading: true,
                cartQuantity: 0,
                toogleShow: false,
                addedQuantity: 0,
            },
        };
    }
    componentDidMount = async () => {
        ReactGA.initialize(trackingId);
        ReactGA.set({
            userId: '540029251114-1j876v4vj9f2fp10ous9neotmca6lle2.apps.googleusercontent.com',
        });

        History.listen((location) => {
            ReactGA.set({ page: location.pathname });
            ReactGA.pageview(location.pathname);
        });

        this.testCookie();
    };
    testCookie = () => {
        //test si token expire
        if (cookies.get('loggedToken')) {
            //appel aPi
            API_BASE.get('/user/token')
                .catch(function (error) {
                    cookies.remove('loggedToken');
                    cookies.remove('accountName');
                    document.location.reload();
                })
                .then((res) => {
                    if (res) {
                        if (res.data.active) {
                            cookies.set('loggedToken', res.data.token, { path: '/', maxAge: 2592000 });
                            cookies.set('accountName', res.data.login, { path: '/', maxAge: 2592000 });
                        } else {
                            cookies.remove('loggedToken');
                            cookies.remove('accountName');
                            document.location.reload();
                        }
                    }
                });
        }
    };

    getDatafromAPI = (offset, page, searchsort) => {
        var bodyData = new FormData();
        var arrayFilters = [];

        bodyData.append('np', page);

        //TEST
        var _productFromAPI = this.state.productsFromAPI;
        _productFromAPI.loading = true;
        this.setState({ productsFromAPI: _productFromAPI });

        //add searchword
        var searchWords = cookies.get('searchWords');
        if (searchWords !== undefined && searchWords !== '') {
            bodyData.append('search', JSON.stringify(searchWords.split(' ')));
            var obj = {};
            var tab = [];
            obj.label = searchWords;
            obj.id = searchWords;
            tab.push(obj);
            window.localStorage.setItem('navMenuClicked', JSON.stringify(tab));
        }

        //recuperation des filtres
        var searchFilters = cookies.get('searchFilters');

        if (searchFilters !== undefined) {
            //recuperation des key
            var keys = Object.keys(searchFilters);
            keys.map((k) => {
                arrayFilters.push(k);
                bodyData.append(k, JSON.stringify(searchFilters[k]));
                return null;
            });
        }

        //recuperation des trie
        if (searchsort !== '') {
            var searchSortArray = [];
            searchSortArray.push(searchsort);
            bodyData.append('byPrice', JSON.stringify(searchSortArray));
        }

        //recherche dans l'api
        API_BASE.post('/client/searchProductsFromES', bodyData, {
            headers: {
                Authorization: 'Bearer ' + cookies.get('loggedToken'),
            },
        })
            .catch(function (error) {
                alert(error);
            })
            .then((res) => {
                if (res) {
                    //test si resultat
                    //traitement des filtres
                    if (localStorage.getItem('isParcouring') === 'true' || localStorage.getItem('isParcouring') === null) {
                        var filters = [];
                        var expendedTemp = [];
                        if (res.data.filters.animals && res.data.filters.animals.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('animals');
                            filters.push({ expended: expendedTemp, label: 'animals', label_web: 'Animaux', buckets: res.data.filters.animals.buckets });
                        }
                        if (res.data.filters.own_category && res.data.filters.own_category.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('own_category');
                            filters.push({
                                expended: expendedTemp,
                                label: 'own_category',
                                label_web: 'Catégories',
                                buckets: res.data.filters.own_category.buckets,
                            });
                        }
                        if (res.data.filters.own_provider && res.data.filters.own_provider.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('own_provider');
                            filters.push({
                                expended: expendedTemp,
                                label: 'own_provider',
                                label_web: 'Laboratoires',
                                buckets: res.data.filters.own_provider.buckets,
                            });
                        }
                        if (res.data.filters.own_mark && res.data.filters.own_mark.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('own_mark');
                            filters.push({ expended: expendedTemp, label: 'own_mark', label_web: 'Marques', buckets: res.data.filters.own_mark.buckets });
                        }
                        if (res.data.filters.typesproducts && res.data.filters.typesproducts.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('typesproducts');
                            filters.push({
                                expended: expendedTemp,
                                label: 'typesproducts',
                                label_web: 'Type du produit',
                                buckets: res.data.filters.typesproducts.buckets,
                            });
                        }
                        if (res.data.filters.own_presentationproduct && res.data.filters.own_presentationproduct.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('own_presentationproduct');
                            filters.push({
                                expended: expendedTemp,
                                label: 'own_presentationproduct',
                                label_web: 'Présentations produit',
                                buckets: res.data.filters.own_presentationproduct.buckets,
                            });
                        }
                        if (res.data.filters.weights && res.data.filters.weights.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('weights');
                            filters.push({ expended: expendedTemp, label: 'weights', label_web: 'Poids', buckets: res.data.filters.weights.buckets });
                        }
                        if (res.data.filters.healthproblems && res.data.filters.healthproblems.buckets.length > 0) {
                            expendedTemp = arrayFilters.includes('healthproblems');
                            filters.push({
                                expended: expendedTemp,
                                label: 'healthproblems',
                                label_web: 'Problèmes de santé',
                                buckets: res.data.filters.healthproblems.buckets,
                            });
                        }
                        res.data.filters = filters;
                    } else {
                        res.data.filters = this.state.productsFromAPI.filters;
                    }
                    localStorage.removeItem('isParcouring');
                    //set offset and page
                    res.data.offset = offset;
                    res.data.page = page;
                    res.data.loading = false;

                    this.setState({ productsFromAPI: res.data });
                    window.scrollTo(0, 0);
                }
            });
    };

    getCartQuantity = async (add) => {
        try {
            var _cartDetails = await API_BASE.get('client/countCart', {
                headers: {
                    Authorization: 'Bearer ' + cookies.get('loggedToken'),
                },
            });
            var temp = this.state.cartQuantity;

            if (_cartDetails.status === 200) {
                this.setState({
                    cartQuantity: _cartDetails.data,
                });
            } else {
                this.setState({
                    cartQuantity: temp,
                });
            }
        } catch {}
    };

    changeToogleShow = (bool) => {
        this.setState({
            toogleShow: bool,
        });
    };
    changeAddedQuantity = (qte) => {
        this.setState({
            addedQuantity: qte,
        });
    };

    getLabel = (id) => {
        var tab = [];
        tab = JSON.parse(window.localStorage.getItem('navMenu'));

        if (tab === null) {
            tab = [];
        }
        var rendertab = {};
        var componentTab = [];
        tab.map((c) => {
            if (c.id === parseInt(id)) {
                rendertab.label = c.label;
                rendertab.id = c.id;
                rendertab.stage = 1;
                componentTab.push(rendertab);
            }
            c.submenu.map((sc) => {
                if (sc.id === parseInt(id)) {
                    rendertab.label = c.label;
                    rendertab.id = c.id;
                    rendertab.stage = sc.label + 2;
                    componentTab.push(rendertab);
                    rendertab = {};
                    rendertab.label = sc.label;
                    rendertab.id = sc.id;
                    rendertab.stage = sc.label + 2;
                    componentTab.push(rendertab);
                    rendertab = {};
                }
                sc.submenu.map((ssc) => {
                    if (ssc.id === parseInt(id)) {
                        rendertab.label = c.label;
                        rendertab.id = c.id;
                        rendertab.stage = ssc.label + 3;
                        componentTab.push(rendertab);
                        rendertab = {};
                        rendertab.label = sc.label;
                        rendertab.id = sc.id;
                        rendertab.stage = ssc.label + 3;
                        componentTab.push(rendertab);
                        rendertab = {};
                        rendertab.label = ssc.label;
                        rendertab.id = ssc.id;
                        rendertab.stage = ssc.label + 3;
                        componentTab.push(rendertab);
                        rendertab = {};
                    }
                    return null;
                });
                return null;
            });
            return null;
        });

        return componentTab;
    };

    render() {
        return (
            <Container fluid>
                <Router history={History}>
                    <ProductsContext.Provider
                        value={{
                            productsFromAPI: this.state.productsFromAPI,
                            getDatafromAPI: this.getDatafromAPI,
                            cartQuantity: this.state.cartQuantity,
                            getCartQuantity: this.getCartQuantity,
                            toogleShow: this.state.toogleShow,
                            changeToogleShow: this.changeToogleShow,
                            addedQuantity: this.state.addedQuantity,
                            changeAddedQuantity: this.changeAddedQuantity,
                            getLabel: this.getLabel,
                        }}
                    >
                        <StickyBox style={{ zIndex: 5, background: '#FFFFFF' }}>
                            <Header />
                        </StickyBox>

                        <Switch>
                            <Route path="/" component={SwitchRoute} />
                            <Route render={() => <Redirect from="/" to="/home" />} />
                        </Switch>

                        <ScrollToTop />

                        <Footer />
                        <CookieConsent
                            location="bottom"
                            sameSite="lax"
                            enableDeclineButton
                            declineButtonText="Refuser"
                            declineButtonStyle={{
                                background: '#ffffff',
                                border: '1px solid #000000',
                                borderRadius: '10px',
                                boxShadow: 'none',
                                color: 'black',
                                cursor: 'pointer',
                                flex: '0 0 auto',
                                padding: '10px 15px',
                                margin: '10px',
                            }}
                            flipButton
                            buttonText="Accepter"
                            cookieName="cookieActivation"
                            style={{ background: '#262626', color: 'white' }}
                            buttonStyle={{
                                background: '#41477a',
                                border: '0',
                                borderRadius: '10px',
                                boxShadow: 'none',
                                color: 'white',
                                cursor: 'pointer',
                                flex: '0 0 auto',
                                padding: '10px 15px',
                                margin: '10px',
                            }}
                            expires={150}
                        >
                            En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de cookies pour vous connecter.
                        </CookieConsent>
                    </ProductsContext.Provider>
                </Router>
            </Container>
        );
    }
}

// Header Render
ReactDOM.render(<App />, document.getElementById('root'));
